import React from 'react';
import { Link, Typography } from '@loomstateorg/shared-frontend';
import { Reference } from 'types/reference';

export interface FooterLink {
  name: string;
  reference: Reference;
  icon: string;
}

export interface Props {
  header?: string;
  links: FooterLink[];
  className?: string;
  headerClassName?: string;
  index?: number;
  children?: React.ReactNode;
}

const Column: React.FC<Props> = ({ header, links, className, headerClassName = 'self-start sm:pb-20', index = 0 }) => {
  return (
    <div className={className}>
      {header && (
        <Typography fontSize={16} medium className={headerClassName} data-testid={`footer-column-title-${index}`}>
          {header}
        </Typography>
      )}
      <ul
        role="list"
        className="mb-3 flex flex-col items-start  gap-y-18 self-start"
        data-testid={`footer-item-list-${index}`}
      >
        {links.map((item, i) => (
          <li key={i}>
            <Link
              link={item.reference}
              className={`${className} hover:opacity-50`}
              data-testid={`footer-item-${index}-${i}`}
            >
              <div className="flex items-center">
                <Typography fontSize={14} fontFamily="primaryThin" className={className}>
                  {item.name}
                </Typography>
                {item.icon && <img src={item.icon} alt={item.name} className="ml-4" />}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Column;
